module.exports = __webpack_public_path__ + "static/media/Biko_Bold.aa61636a.otf";